import React, { useEffect, useState } from "react";
import CardProduto, { Produto } from "../CardProduto/CardProduto";
import styles from "./ProdutosMaisRecentes.module.css";
import api from "../../utils/axios/api";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const ProdutosMaisRecentes: React.FC = () => {
  const [produtosRecentes, setProdutosRecentes] = useState<Produto[]>([]);

  useEffect(() => {
    async function LoadProducts() {
      const response = await api.get(`/product?filter=recentes`);
      const lista = Array.isArray(response.data)
        ? response.data.slice(0, 24)   // limita a 24 itens se for array
        : [];
      setProdutosRecentes(lista);
    }
    LoadProducts();
  }, []);

  return (
    <div className={styles.produtosRecenteContainer}>
      <Swiper
        spaceBetween={50}
        style={{ padding: "8px 20px" }}
        grabCursor={true}
        breakpoints={{
          320: { slidesPerView: 2.5 },
          640: { slidesPerView: 3.5 },
          768: { slidesPerView: 4.5 },
          1024: { slidesPerView: 5.5 },
          1200: { slidesPerView: 6.5 },
        }}
      >
        <div className={styles.produtosRecenteLista}>
          {Array.isArray(produtosRecentes)
            ? produtosRecentes.map((produto) => (
                <SwiperSlide key={produto.id}>
                  <CardProduto produto={produto} />
                </SwiperSlide>
              ))
            : null}
        </div>
      </Swiper>
    </div>
  );
};

export default ProdutosMaisRecentes;
